<script lang="ts">
  import {getContext} from 'svelte';
  import lang from '../LoginPage.lang';

  let className ='';
  export {className as class};

  export let LG = getContext('LG')
</script>
<style lang="scss">
  .security {
    padding: 12px 0;
    color: #1D2029;
    background: #F5F7FA;
    gap: 4px;
  }
  @media screen and (max-width: 640px) {
    .security {
      margin-top: 40px;
    }
  }
</style>
<div class="df aic jcc pv12 security {className}">
  <img width="20" height="20" src="https://img.phemex.com/v1/b0032e6b-8ce3-409c-b9fa-ae874eac98a5/shield-security.png" alt="security"/>
  <span class="f12 fw2 lh16">{LG(lang.OfficialWebsite)}: https://phemex.com</span>
</div>
